import { useState } from "react";
import { Link } from "react-router-dom";
import { recommendMethods } from "../data/methodsData";

const goals = [
    { value: "yodlash", label: "Yodlash va eslab qolish" },
    { value: "tahlil", label: "Tahlil qilish" },
    { value: "ijodkorlik", label: "Ijodkorlik" },
    { value: "amaliyot", label: "Amaliyotga yo'naltirish" },
    { value: "hamkorlik", label: "Hamkorlik / jamoaviy ish" },
    { value: "rejalashtirish", label: "Rejalashtirish" },
    { value: "muammo_yechish", label: "Muammo yechish" },
    { value: "baholash", label: "Baholash" },
    { value: "til", label: "Til o'rganish" },
    { value: "o'qish", label: "Matn o'qish" },
];

const grades = [
    { value: "boshlang'ich", label: "Boshlang'ich (1-4)" },
    { value: "o'rta", label: "O'rta (5-9)" },
    { value: "yuqori", label: "Yuqori / Talaba" },
];

const times = [
    { value: "qisqa", label: "Qisqa (15-30 daqiqa)" },
    { value: "o'rta", label: "O'rta (1 dars)" },
    { value: "uzoq", label: "Uzoq (loyiha / hafta)" },
];

function MethodRecommender() {
    const [form, setForm] = useState({ goal: "", subject: "", grade: "", time: "" });
    const [results, setResults] = useState(null);

    const handleSubmit = (e) => {
        e.preventDefault();
        setResults(recommendMethods(form).slice(0, 3));
    };

    return (
        <>
            <section className="page-header">
                <div className="container">
                    <div className="page-header__content">
                        <ul className="eduhive-breadcrumb list-unstyled">
                            <li><span className="eduhive-breadcrumb__icon"><i className="icon-home"></i></span><Link to="/">Bosh sahifa</Link></li>
                            <li><span>Metod tavsiyachi</span></li>
                        </ul>
                        <h2 className="page-header__title">Metod tavsiyachi</h2>
                    </div>
                </div>
                <img src="/assets/images/page-header-shape-1.png" alt="shape" className="page-header__shape-one" />
                <img src="/assets/images/page-header-shape-2.png" alt="shape" className="page-header__shape-two" />
            </section>

            <section className="pricing-one section-space-bottom">
                <div className="container">
                    <div className="pricing-one__main-tab-box tabs-box mb-5">
                        <div className="pricing-one__top">
                            <div className="pricing-one__content">
                                <h3 className="pricing-one__title">Sizga qaysi metod mos?</h3>
                                <p className="pricing-one__text">
                                    Quyidagi 4 ta savolga javob bering — ekspert tizim sizga mos pedagogik metodlarni tavsiya etadi.
                                </p>
                            </div>
                        </div>
                        <div className="pricing-one__inner px-3 px-lg-5">
                            <form onSubmit={handleSubmit}>
                                <div className="row gutter-y-30">
                                    <div className="col-md-6">
                                        <label className="d-block mb-2"><strong>Asosiy maqsad</strong></label>
                                        <select
                                            required
                                            className="form-control"
                                            style={{ padding: "12px", border: "1px solid #ddd", borderRadius: "8px", width: "100%" }}
                                            value={form.goal}
                                            onChange={(e) => setForm({ ...form, goal: e.target.value })}
                                        >
                                            <option value="">— tanlang —</option>
                                            {goals.map((g) => <option key={g.value} value={g.value}>{g.label}</option>)}
                                        </select>
                                    </div>
                                    <div className="col-md-6">
                                        <label className="d-block mb-2"><strong>Fan / mavzu</strong></label>
                                        <input
                                            type="text"
                                            placeholder="masalan: adabiyot, ona tili, pedagogika"
                                            className="form-control"
                                            style={{ padding: "12px", border: "1px solid #ddd", borderRadius: "8px", width: "100%" }}
                                            value={form.subject}
                                            onChange={(e) => setForm({ ...form, subject: e.target.value })}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="d-block mb-2"><strong>Sinf darajasi</strong></label>
                                        <select
                                            required
                                            className="form-control"
                                            style={{ padding: "12px", border: "1px solid #ddd", borderRadius: "8px", width: "100%" }}
                                            value={form.grade}
                                            onChange={(e) => setForm({ ...form, grade: e.target.value })}
                                        >
                                            <option value="">— tanlang —</option>
                                            {grades.map((g) => <option key={g.value} value={g.value}>{g.label}</option>)}
                                        </select>
                                    </div>
                                    <div className="col-md-6">
                                        <label className="d-block mb-2"><strong>Mavjud vaqt</strong></label>
                                        <select
                                            required
                                            className="form-control"
                                            style={{ padding: "12px", border: "1px solid #ddd", borderRadius: "8px", width: "100%" }}
                                            value={form.time}
                                            onChange={(e) => setForm({ ...form, time: e.target.value })}
                                        >
                                            <option value="">— tanlang —</option>
                                            {times.map((t) => <option key={t.value} value={t.value}>{t.label}</option>)}
                                        </select>
                                    </div>
                                </div>
                                <div className="text-center mt-5">
                                    <button type="submit" className="eduhive-btn" style={{ border: "none" }}>
                                        <span>Tavsiya olish</span>
                                        <span className="eduhive-btn__icon">
                                            <span className="eduhive-btn__icon__inner"><i className="icon-right-arrow"></i></span>
                                        </span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>

                    {results && (
                        <div className="pricing-one__main-tab-box tabs-box">
                            <div className="pricing-one__top">
                                <div className="pricing-one__content">
                                    <h3 className="pricing-one__title">Eng mos metodlar</h3>
                                    <p className="pricing-one__text">Ekspert tizim ball asosida saralangan natijalar:</p>
                                </div>
                            </div>
                            <div className="pricing-one__inner px-3 px-lg-5">
                                <div className="row gutter-y-30">
                                    {results.map((m, i) => (
                                        <div className="col-md-4" key={m.id}>
                                            <div className="pricing-one__card" style={{ position: "relative" }}>
                                                <div style={{
                                                    position: "absolute",
                                                    top: "15px",
                                                    right: "15px",
                                                    background: i === 0 ? "#ffb606" : "#f5f5f5",
                                                    color: i === 0 ? "#fff" : "#333",
                                                    padding: "6px 14px",
                                                    borderRadius: "20px",
                                                    fontWeight: 700,
                                                }}>
                                                    {i + 1}-o'rin
                                                </div>
                                                <h3 className="pricing-one__card__title">{m.name}</h3>
                                                <p className="pricing-one__card__text">{m.short}</p>
                                                <div style={{
                                                    background: "#f8f8f8",
                                                    padding: "10px 15px",
                                                    borderRadius: "8px",
                                                    marginBottom: "20px"
                                                }}>
                                                    <strong>Moslik balli:</strong> {m.score}/100
                                                    <div style={{ background: "#e0e0e0", borderRadius: "4px", height: "8px", marginTop: "8px" }}>
                                                        <div style={{
                                                            background: "#ffb606",
                                                            borderRadius: "4px",
                                                            height: "8px",
                                                            width: `${Math.min(m.score, 100)}%`,
                                                            transition: "width 0.6s"
                                                        }}></div>
                                                    </div>
                                                </div>
                                                <Link to={m.path} className="eduhive-btn">
                                                    <span>Metodni ko'rish</span>
                                                    <span className="eduhive-btn__icon">
                                                        <span className="eduhive-btn__icon__inner"><i className="icon-right-arrow"></i></span>
                                                    </span>
                                                </Link>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </section>
        </>
    );
}

export default MethodRecommender;
